import {CargoRequirementChoice} from '@logistics-frontend/types/schemas/services/delivery-corp-account-api/api/form'
import {get} from '@logistics-frontend/utils'

export const getCargoLoadersOptions: (cargoTypeOption: CargoRequirementChoice | undefined) => number[] | undefined =
  get('restrictions.cargo_loaders.values')
